import { render, staticRenderFns } from "./HomeDemoFour.vue?vue&type=template&id=92809996&"
import script from "./HomeDemoFour.vue?vue&type=script&lang=js&"
export * from "./HomeDemoFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports